import { recoverStaleAssets } from "./lib/deployRecovery";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { AuthProvider } from "./contexts/AuthContext";
import App from "./App";
import { PWAUpdatePrompt } from "./components/PWAUpdatePrompt";
import "./styles/index.css";
import "./styles/design-system.css";

window.addEventListener("vite:preloadError", (event) => {
  if (recoverStaleAssets()) event.preventDefault();
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const message =
    typeof reason === "string"
      ? reason
      : reason instanceof Error
        ? reason.message
        : "";
  if (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Loading chunk") ||
    message.includes("Importing a module script failed")
  ) {
    if (recoverStaleAssets()) event.preventDefault();
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <PWAUpdatePrompt />
        <Analytics beforeSend={(event) => /\/book-request(?:\/|$)/.test(event.url) ? null : event} />
        <SpeedInsights beforeSend={(event) => /\/book-request(?:\/|$)/.test(event.url) ? null : event} />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
